<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-item :to="'/sensordashboard'" index="1" icon="cloud_queue">
      Overview
    </vs-sidebar-item>
    <vs-sidebar-item :to="'/report'" index="2" icon="description">
      Report
    </vs-sidebar-item>

    <vs-sidebar-item :to="'/map-sensor'" index="3" icon="room"> Map </vs-sidebar-item>
    <vs-sidebar-group open title="Device Mangement">
      <vs-sidebar-item :to="'/sensor'" index="2.1" icon="signal_cellular_alt">
        Device
      </vs-sidebar-item>
    </vs-sidebar-group>

    <vs-sidebar-group open title="Setting">
      <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
        Network
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/user'" index="2.3" icon="person">
        User
      </vs-sidebar-item>
    </vs-sidebar-group>

    <footer-sidebar slot="footer"></footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "ngkSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return { username: "", sensorlist: {} };
  },
  methods: {
    // link2(item) {
    //   this.$session.set("nwname", item.network);
    //   this.$session.set("statussensor", item.active);
    //   this.$session.set("nwid", item.nwid);
    //   this.$session.set("sensorname", item.name);
    //   this.$session.set("sensorid", item.serial_id);
    //   this.$session.set("gatewayid", item.gatewayid);
    //   this.$session.set("type", item.type);
    //   this.$session.set("lora", item.lora);
    //   this.$session.set("location", item.location);
    //   this.$session.set("idsensor", this.findID(item));
    //   // // console.log(this.network,item)
    //   //       this.$router.push({
    //   //         name: "SensorDashboard",
    //   //         params: {
    //   //           nwname: this.network,
    //   //           nwid: item.nwid,
    //   //           sensorid: item.serial_id,
    //   //           gatewayid: item.gatewayid,
    //   //           type: item.type,
    //   //         },
    //   //       });
    // },
  },
  // async created() {
  //   this.username = this.$session.get("username");
  //   this.role = this.$session.get("role");
  //   await this.$API.get("network/user").then((result) => {
  //     //       console.log(result.data);
  //   });
  //   await this.$API.get("sensors/user").then((result) => {
  //     this.link2(result.data[0]);
  //     // // console.log(this.sensorlist)
  //   });
  // },
};
</script>

<style>
</style>